import * as utils from '@/utils'
export default Vue => {
  Vue.prototype.$notify = function (opt) {
    return this.$vs.notify({
      color: "success",
      position: "top-center",
      ...opt,
    })
  }

  Vue.prototype.$util = utils

}